import {useEffect, useMemo, useState} from 'react';
import {
  getAgentInfo,
  getTodayEarningsChart,
} from '@/common-pages/proxy/proxy.service';
import {AgentInfo, TodayEarningsChart} from '@/common-pages/proxy/proxy.type';
import {goTo} from '@/utils';
import globalStore from '@/services/global.state';

export function useAgentContent() {
  const [agentInfo, setAgentInfo] = useState<AgentInfo | undefined>();
  const [chart, setChart] = useState<TodayEarningsChart | undefined>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 优先检查是否登录，未登录时直接跳转，不执行任何接口请求
    const isLoggedIn = !!globalStore.token;
    if (!isLoggedIn) {
      goTo('AgentPage');
      return;
    }

    // 检查是否为代理（使用 globalStore.userInfo?.isAgent === 1 判断）
    // 如果不是代理，也跳转到AgentPage，不执行接口请求
    if (globalStore.userInfo?.isAgent !== 1) {
      goTo('AgentPage');
      return;
    }

    // 只有已登录且是代理时，才执行接口请求
    setLoading(true);
    Promise.allSettled([getAgentInfo(), getTodayEarningsChart()])
      .then(([agent, chartRes]) => {
        if (agent.status === 'fulfilled') {
          setAgentInfo(agent.value);
        }
        if (chartRes.status === 'fulfilled') {
          setChart(chartRes.value);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const earningsList = useMemo(() => chart?.earningsChartList || [], [chart]);

  return {
    agentInfo,
    chart,
    earningsList,
    loading,
  };
}
